/**
 * PC_FHA_01 importing the api functions and react functions
 */
import { useState, useEffect } from "react";
import React from "react";
import { getFlagCountAndName, getFeedbackHeaderDetails, postHrApproval } from "../service/DirectorAPI";
import { NotificationTrigger } from '../../src/utils/RegHandling';
import moment from "moment";
import $ from 'jquery';
import { connect } from 'react-redux';
import { encryptStorage } from '../constant'
/**
 * 
 *  PC_FHA_01.1 this function will return the html
 */
function HrApproveFeedback(props) {

    /**
     * PC_FHA_02 creating objects state variables
     */

    let IndivFlagCounts = {
        green_flag: "",
        red_flag: "",
        yellow_flag: "",
        emp_name: "",
        role: "",
        profile_img_url: ""
    };

    let HeaderData = {
        FlagRaised: "",
        UpdatedBy: "",
        UpdatedDate: "",
        CommentsBasedOn: ""
    };

    let FeedbackData = {
        Acknowledgement: 0
    };

    const [feedbackdata, setFeedbackdata] = useState(FeedbackData);
    const [indivFlagCountsData, setIndivFlagCountsData] = useState(IndivFlagCounts);
    const [headerdata, setHeaderdata] = useState(HeaderData);
    const [empId, SetEmpId] = useState(props.empId);
    let FeedbackId = props.FeedbackId;
    let EvaluationId = props.EvaluationId;
    let FeedbackDataId = props.feedbackDataID
    let flags = props.Flag;
    let login_emp_id = encryptStorage.getItem("employeeId");
    let role = props.role;
    const [hideForm, setHideForm] = useState(true);

    /**
     * PC_FHA_03 this method invock the loadFlagCountPage(),
     * getFeedbackHeaderData() functions
     */
    useEffect(() => {
        if (props.isHrApproveClicked == true) {
            setHideForm(false);

            // let element = document.getElementById("removeScroll");
            // element.classList.add("removeScroll");
            $("body").addClass("removeScroll");

            loadFlagCountPage();
            getFeedbackHeaderData();
        }
    }, [props]);


    /**
     * PC_FHA_03.1 this function retrive the flag counts from the db 
     * for specific employee for current evaluation period
     */
    const loadFlagCountPage = async () => {

        try {

            let empdata = {

                evaluation_id: EvaluationId,
                emp_id: props.empId,
                login_emp_id: login_emp_id
            };

            let data = await getFlagCountAndName(empdata);


            if (data.data != undefined && data.data != null && data.data.ResponseData[0].length != 0) {



                let IndivFlagCounts = {
                    green_flag: data.data.ResponseData[0].green_flag,
                    red_flag: data.data.ResponseData[0].red_flag,
                    yellow_flag: data.data.ResponseData[0].yellow_flag,
                    emp_name: data.data.ResponseData[0].emp_name,
                    role: data.data.ResponseData[0].domain,
                    profile_img_url: data.data.ResponseData[0].profile_img_url
                };



                setIndivFlagCountsData(IndivFlagCounts);
            }

        } catch (e) {

        }
    };

    /**
     * PC_FHA_03.1 this function will retrive the feedback data from db
     */
    const getFeedbackHeaderData = async () => {

        try {

            let empdata = {

                feedback_data_id: FeedbackDataId,
                evaluation_id: EvaluationId,
                feedback_id: FeedbackId,
                emp_id: empId,
            };

            let data = await getFeedbackHeaderDetails(empdata);

            if (data.data != undefined && data.data != null && data.data.ResponseData[0].length != 0) {


                let date = moment(new Date(data.data.ResponseData[0][0].created_at));
                let UpdatedDate = date.format("MMM DD, YYYY");


                let HeaderData = {

                    FlagRaised: data.data.ResponseData[0][0].flags,
                    UpdatedBy: data.data.ResponseData[0][0].updatedby,
                    UpdatedDate: UpdatedDate,
                    CommentsBasedOn: data.data.ResponseData[0][0].comments_based_on
                };


                setHeaderdata(HeaderData);
            }

        } catch (e) {


        }
    };
    let validationFields = {
        Acknowledgement: ""

    }
    const [message, setmessage] = useState(validationFields);


    /**
     * PC_FHA_11 this function will clear the all fields values from the variables
     */
    const cancelClick = () => {

        let valiclearoption = {
            Acknowledgement: 0
        };
        setFeedbackdata(valiclearoption);

        let ClearValidationFields = {
            Acknowledgement: ""

        }
        setmessage(ClearValidationFields);
        props.setIsHrApproveClick(false);
        setHideForm(true);

        // let element = document.getElementById("removeScroll");
        // element.classList.remove("removeScroll");
        $("body").removeClass("removeScroll");

    }

    /**
     * 
     * PC_FHA_03.2 this function set the value into the state variable
     */
    const handleChecked = (e) => {

        e.target.checked == true
            ? setFeedbackdata({ ...feedbackdata, [e.target.name]: 1 })
            : setFeedbackdata({ ...feedbackdata, [e.target.name]: 0 });

    };

    /**
     * PC_FHA_04 this function will validate the manditary fields before submitting the form
     */

    const validation = () => {

        if (feedbackdata.Acknowledgement == 0) {
            message.Acknowledgement = "Yes, Team Member agreed with the decision is required"
            setmessage({ ...message });
        }

    }

    /**
    * PC_FHA_04 this function will validate and post the data 
    * into the db and send the notification
    */
    const submitClick = async () => {

        validation();
        try {
         
            if (
                feedbackdata.Acknowledgement != 0
            ) {
                let insertdata = {
                    id: FeedbackId,
                    evaluation_id: EvaluationId,
                    emp_id: empId,
                    login_emp_id: login_emp_id,
                    feedback_by_role: role,
                    feedback_data_id: FeedbackDataId,
                    flags: flags,
                    hr_response: "Agreed",
                    emp_response: "Agreed"
                };

            
                let responsedata = await postHrApproval(insertdata);
                if (responsedata.data.status == 200) {

                    let notificationids = [];
                    notificationids.push(responsedata.data.ResponseData[0]);

                    let emp = [];
                    notificationids[0].map((obj, index) => {

                        if (obj.emp_id != login_emp_id && !emp.includes(obj.emp_id)) {
                            emp.push(obj.emp_id);
                        }

                    });

                    emp.push(empId);
                    let value=  (props.empId)

                    await NotificationTrigger({ title: "Feedback", message: 'Feedback has been approved', route: `/Feedback?EmpId=${value}&FeedbackId=${FeedbackId}&EvaluationId=${EvaluationId}&IsProfile=true&IsTeamMember=true`, state: {}, to_employee: emp, by: login_emp_id }, emp, props.websocket)
                    let valiclearoption = {
                        Acknowledgement: 0
                    };
                    setFeedbackdata(valiclearoption);
                    props.setIsHrApproveClick(false);
                    props.Reload();
                    cancelClick();
                }

            }
        } catch (e) {

        }


    }

    return (
        <div className="modal fade show"
            style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.6)' }}
            hidden={hideForm}>

            <div className="modal-dialog modal-lg">
                <div className="modal-content">
                    <div className="modal-header border-0">
                        <h5 className="modal-title profile-popup-header" id="AddFeedbackDetailsPopupLabel">Feedback Approve</h5>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={() => cancelClick()} />
                    </div>
                    <div className="modal-body">
                        <div className="row mb-4">
                            <div className="col-md-12 profile-spacing mb-4">
                                <div className="profile-left d-flex">
                                    <div className="d-flex">
                                        <img src="/Images/logo-person-user-person-icon.jpg" alt="User Profile Image" className="profile-image-feedback" />
                                    </div>
                                    <div className="d-grid ms-3">
                                        <span className="font-14 semibold-text team-member-name">{indivFlagCountsData.emp_name}</span>
                                        <span className="font-14 pb-0 pt-1 regular-text my-0">{indivFlagCountsData.role}</span>
                                    </div>
                                </div>
                                <div className="d-flex">
                                    <div className=" d-flex align-items-center me-5">
                                        <div className="profile-feedback-panel profile-feedback-panel-popup profile-feedback-green">
                                        </div>
                                        <div className="text-center profile-flag-count mx-2">{indivFlagCountsData.green_flag}</div>
                                    </div>
                                    <div className=" d-flex align-items-center me-5">
                                        <div className="profile-feedback-panel profile-feedback-panel-popup profile-feedback-yellow">
                                        </div>
                                        <div className="text-center profile-flag-count mx-2">{indivFlagCountsData.yellow_flag}</div>
                                    </div>
                                    <div className=" d-flex align-items-center">
                                        <div className="profile-feedback-panel profile-feedback-panel-popup profile-feedback-red">
                                        </div>
                                        <div className="text-center profile-flag-count mx-2">{indivFlagCountsData.red_flag}</div>
                                    </div>
                                </div>
                            </div>
                            <div className="row mt-5 mb-2">
                                <div className="col-md-2"><label className="tt-bold font-14 mb-3 feedback-form-label">Flag Raised</label>
                                    {headerdata.FlagRaised == "G" ? (<p className="feedback-text mb-0 semibold-text font-14 mt-2"><span><img src="/Images/Green-Flag.svg" className="pe-2" /></span>Green Flag</p>) : null}
                                    {headerdata.FlagRaised == "R" ? (<p className="feedback-text mb-0 semibold-text font-14 mt-2"><span><img src="/Images/red-flag.svg" className="pe-2" /></span>Red Flag</p>) : null}
                                    {headerdata.FlagRaised == "Y" ? (<p className="feedback-text mb-0 semibold-text font-14 mt-2"><span><img src="/Images/Yellow-Flag.svg" className="pe-2" /></span>Yellow Flag</p>) : null}
                                </div><div className="col-md-2"><label className="tt-bold font-14 mb-3 feedback-form-label">Raised by</label>
                                    <div className="d-flex align-self-center"><div><img src="/Images/logo-person-user-person-icon.jpg" className="me-2 feedback-updatedby-img" alt="img" /></div>
                                        <div className="d-block  align-self-center"><p className="feedback-text semibold-text font-14 mt-2">{headerdata.UpdatedBy}</p></div>
                                    </div>
                                </div>
                                <div className="col-md-2"><label className="tt-bold font-14 mb-3 feedback-form-label">Raised Date</label>
                                    <p className="feedback-text mb-0 semibold-text font-14 mt-2">{headerdata.UpdatedDate}</p></div>
                                <div className="col-md-4"><label className="tt-bold font-14 mb-3 feedback-form-label">Feedback</label>
                                    <p className="feedback-text semibold-text font-14 mb-0 mt-2">{headerdata.CommentsBasedOn}</p>
                                </div>
                            </div>

                            <div className="col-md-12 mb-4 mt-4">

                                <div className="form-check form-check-inline">
                                    <input className="form-check-input hive-form-check-input" type="checkbox" id="CommunicationCheckbox" name="Acknowledgement"
                                        checked={feedbackdata.Acknowledgement == 1 ? 1 : 0} onClick={(e) => handleChecked(e)} />
                                    <label className="form-check-label hive-form-check-label" htmlFor="CommunicationCheckbox">Yes, Team Member agreed with the decision</label>
                                </div>
                                {message.Acknowledgement ? <label className=" hive-form-label w-100 hive-form-mandatory">{message.Acknowledgement}</label> : null}
                            </div>
                        </div>
                    </div>
                    <div className="modal-footer border-0">
                        <button type="button" className="btn hive-btn-secondary" data-bs-dismiss="modal" onClick={() => cancelClick()}>Cancel</button>
                        <button type="button" className="btn hive-btn-primary" onClick={() => submitClick()}>Update</button>
                    </div>
                </div>
            </div>
        </div>


    );
}


function mapStateToProps(state) {

    return {
        websocket: state.webSocketAPI
    }
}

export default connect(mapStateToProps)(HrApproveFeedback)